import { gql } from '@apollo/client'

export const BASE_PROMO_CODE_FIELDS = gql`
  fragment BasePromocodeFields on PromocodeType {
    id
    name
    code
    description
    type
    status
    amount
    # membershipType
    additionalTest {
      id
    }
    product {
      id
    }
    changeMembershipLengthBy
    expirationDate
    maxUses
    alreadyUsed
    isPauseTokenDisabled
    createdAt
    deletedAt
    platform {
      id
      slug
      title
    }
  }
`

export const GET_LIST_PROMO_CODES = gql`
  ${BASE_PROMO_CODE_FIELDS}
  query findAllPromoCodes($query: PromocodeQueryInput! = {}) {
    findAllPromocode(query: $query) {
      count
      items {
        ...BasePromocodeFields
      }
    }
  }
`

export const GET_ONE_PROMO_CODE = gql`
  ${BASE_PROMO_CODE_FIELDS}
  query findOnePromoCode($id: String!) {
    findOnePromocode(id: $id) {
      ...BasePromocodeFields
    }
  }
`

export const FIND_PROMO_CODE_HISTORY_DATA = gql`
  query findPromocodeHistoryData($query: PromocodeHistoryQueryInput!, $graphQuery: PromocodeHistoryQueryInput!) {
    findPromocodeHistory(query: $query) {
      totalUsed
      totalRevenue
    }
    findPromocodeHistoryGraph(query: $graphQuery) {
      date
      promoUsed
    }
  }
`

export const UPDATE_PROMO_CODE = gql`
  mutation updatePromoCode($params: UpdatePromocodeInput!) {
    updatePromocode(updatePromocodeInputFieldName: $params) {
      id
      isPauseTokenDisabled
    }
  }
`

export const CREATE_PROMO_CODE = gql`
  mutation createPromoCode($params: CreatePromocodeInput!) {
    createPromocode(createPromocodeInput: $params) {
      id
      isPauseTokenDisabled
    }
  }
`

export const REMOVE_PROMO_CODE = gql`
  mutation removePromoCode($id: String!) {
    removePromocode(id: $id) {
      affected
      raw
    }
  }
`

export const BULK_UPDATE_PROMO_CODES = gql`
  mutation bulkUpdatePromoCodes($items: [BulkUpdatePromocodeInput!]!) {
    bulkUpdatePromocode(bulkUpdatePromocodeInput: $items) {
      id
    }
  }
`

export const BULK_REMOVE_PROMO_CODES = gql`
  mutation bulkRemovePromoCodes($ids: [LinkPromocodeInput!]!) {
    bulkRemovePromocode(ids: $ids) {
      affected
      raw
    }
  }
`
